export default __webpack_public_path__ + "static/media/learose-768w.6779e16f.avif";